import type { EnvironmentUtils } from '@change-corgi/core/environment';

import { AMPLITUDE_CONFIG } from '#config/amplitude';

import type { Session } from '#src/shared/session';

import type { AmplitudeReplay, AmplitudeReplayConfig } from '#src/app/shared/utils/amplitudeReplay';
import {
	createAmplitudeReplay as createAmplitudeReplayBase,
	createFakeAmplitudeReplay,
} from '#src/app/shared/utils/amplitudeReplay';

type Options = {
	config: AmplitudeReplayConfig;
	environment: EnvironmentUtils;
	session: Session;
};

export function createAmplitudeReplay(options: Options): AmplitudeReplay {
	const apiKey = AMPLITUDE_CONFIG[options.environment.getEnvironment()];
	if (apiKey) {
		return createAmplitudeReplayBase({
			apiKey,
			config: options.config,
			htmlPiiSelectors: {
				mask: ['[data-pii-unsafe]'],
				unmask: ['[data-pii-safe]'],
			},
			deviceId: options.session.amplitudeSessionReplayConfig.deviceId,
			sessionId: options.session.amplitudeSessionReplayConfig.sessionId,
		}).setLoggingEnabled(process.env.NODE_ENV === 'development');
	}
	return createFakeAmplitudeReplay(options).setLoggingEnabled(process.env.NODE_ENV === 'development');
}
